<template>
  <div class="wrapper">
    <div class="w-full flex items-center justify-center">
      <div class="card flex flex-col bg-white rounded max-w-sm w-full">
        <div class="w-full flex justify-between items-center pb-8">
          <h3 class="nxp-section-title">
            Informe sua formação
          </h3>
          <div @click="closePage" class="closeBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path
                d="M15.5187 4.83176C15.4416 4.75451 15.3501 4.69322 15.2493 4.6514C15.1484 4.60958 15.0404 4.58806 14.9312 4.58806C14.8221 4.58806 14.714 4.60958 14.6132 4.6514C14.5124 4.69322 14.4208 4.75451 14.3437 4.83176L10.2687 8.89843L6.19374 4.82343C6.11659 4.74628 6.025 4.68508 5.92419 4.64332C5.82339 4.60157 5.71535 4.58008 5.60624 4.58008C5.49713 4.58008 5.38909 4.60157 5.28829 4.64332C5.18748 4.68508 5.09589 4.74628 5.01874 4.82343C4.94159 4.90058 4.88039 4.99217 4.83864 5.09298C4.79688 5.19378 4.77539 5.30182 4.77539 5.41093C4.77539 5.52004 4.79688 5.62808 4.83864 5.72888C4.88039 5.82968 4.94159 5.92128 5.01874 5.99843L9.09374 10.0734L5.01874 14.1484C4.94159 14.2256 4.88039 14.3172 4.83864 14.418C4.79688 14.5188 4.77539 14.6268 4.77539 14.7359C4.77539 14.845 4.79688 14.9531 4.83864 15.0539C4.88039 15.1547 4.94159 15.2463 5.01874 15.3234C5.09589 15.4006 5.18748 15.4618 5.28829 15.5035C5.38909 15.5453 5.49713 15.5668 5.60624 15.5668C5.71535 15.5668 5.82339 15.5453 5.92419 15.5035C6.025 15.4618 6.11659 15.4006 6.19374 15.3234L10.2687 11.2484L14.3437 15.3234C14.4209 15.4006 14.5125 15.4618 14.6133 15.5035C14.7141 15.5453 14.8221 15.5668 14.9312 15.5668C15.0403 15.5668 15.1484 15.5453 15.2492 15.5035C15.35 15.4618 15.4416 15.4006 15.5187 15.3234C15.5959 15.2463 15.6571 15.1547 15.6988 15.0539C15.7406 14.9531 15.7621 14.845 15.7621 14.7359C15.7621 14.6268 15.7406 14.5188 15.6988 14.418C15.6571 14.3172 15.5959 14.2256 15.5187 14.1484L11.4437 10.0734L15.5187 5.99843C15.8354 5.68176 15.8354 5.14843 15.5187 4.83176Z"
                fill="#696969" />
            </svg>
          </div>
        </div>

        <ValidationObserver class="w-full" ref="observer" tag="form" v-slot="{ invalid }"
          @submit.prevent="submit()">
          <div class="w-full flex flex-col space-y-4 mt-8">

            <ValidationProvider name="escolaridade" rules="required" v-slot="{ errors }">
              <div class="w-full flex flex-col space-y-4">
                <label for="scholarity" class="nxp-label">Escolaridade</label>
                <v-select id="scholarity" class="mb-1" :options="scholarities" :reduce="scholarity => scholarity.value"
                  v-model="payload.scholarity">
                  <template #search="{ attributes, events }">
                    <input class="vs__search" :required="!payload.scholarity" v-bind="attributes" v-on="events" />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </div>
            </ValidationProvider>

            <ValidationProvider name="escolaridade" rules="required" v-slot="{ errors }">
              <div class="w-full flex flex-col space-y-4">
                <label for="level" class="nxp-label">Status</label>
                <v-select id="level" class="mb-1" name="level" :options="levels" :reduce="level => level.value"
                  v-model="payload.level" @input="onLevelChange">
                  <template #search="{ attributes, events }">
                    <input class="vs__search" :required="!payload.level" v-bind="attributes" v-on="events" />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </div>
            </ValidationProvider>

            <div class="w-full flex flex-row space-x-4">
              <ValidationProvider rules="required|monthYear" name="data_inicio" v-slot="{ errors }" mode="lazy">
                <div class="w-full flex flex-col space-y-2">
                  <label for="from_date" class="nxp-label">Data de início</label>
                  <span class="nxp-sublabel">
                    Mês e ano (Ex:. 01/2006)
                  </span>
                  <vs-input id="from_date" ref="from_date" class="w-full no-icon-border mb-1" type="text"
                    placeholder="___/_____" v-mask="'##/####'" v-model="payload.from_date" :danger="errors.length" />
                  <span class="text-danger text-xs">
                    {{ errors[0] }}
                  </span>
                </div>
              </ValidationProvider>

              <ValidationProvider :rules="inProgress ? '' : 'required|monthYear'" name="data_saida" v-slot="{ errors }" vid="confirmation"
                mode="lazy">
                <div class="w-full flex flex-col space-y-2">
                  <label for="to_date" class="nxp-label">Data de finalização</label>
                  <span class="nxp-sublabel">
                    Mês e ano (Ex:. 01/2006)
                  </span>
                  <vs-input id="to_date" class="w-full no-icon-border mb-1" type="text" placeholder="___/_____"
                    v-mask="'##/####'" v-model="payload.to_date" :danger="errors.length"
                    :disabled="inProgress" />
                  <span v-if="inProgress" class="text-warning text-xs">
                    Não aplicável para o status "Em andamento"
                  </span>
                  <span v-else class="text-danger text-xs">
                    {{ errors[0] }}
                  </span>
                </div>
              </ValidationProvider>
            </div>

            <div class="w-full flex flex-col space-y-2">
              <label for="institute" class="nxp-label">
                Instituição
              </label>
              <vs-input id="institute" class="w-full no-icon-border mb-1" name="institute" type="text"
                v-model="payload.institute" />
              <span class="text-danger text-xs">
                {{ errors[0] }}
              </span>
            </div>

            <ValidationProvider v-if="showCourse()" name="escolaridade" rules="required" v-slot="{ errors }">
              <div class="w-full flex flex-col space-y-2">
                <label for="grade" class="nxp-label">
                  Curso
                </label>
                <v-select id="grade" class="w-full" name="grade" :options="higherEducation" taggable pushTags
                  v-model="payload.grade">
                  <template #search="{ attributes, events }">
                    <input class="vs__search" :required="!payload.grade" v-bind="attributes" v-on="events" />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </div>
            </ValidationProvider>

            <div class="w-full flex flex-col space-y-2" v-if="!showCourse()">
              <ValidationProvider name="grade" v-slot="{ errors, valid }">
                <vs-input class="w-full no-icon-border mb-1" :disabled="isDisabled()" type="text" label="Curso"
                  v-model="payload.grade" :danger="!valid" :danger-text="errors[0] || ''" />
              </ValidationProvider>
            </div>

            <div class="w-full h-6">

            </div>
            <button :disabled="invalid" :style="{ background: color }" class="nxp-continue-btn" type="submit">
              Salvar
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { isBefore } from "date-fns";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    ModelSelect,
    "v-select": vSelect
  },
  props: ["formation"],
  data: () => ({
    payload: {
      index: 0,
      popupActive: false,
      scholarity: "",
      institute: "",
      level: "",
      grade: "",
      to_date: "",
      from_date: ""
    },
    scholarities: [
      { value: "Curso Técnico", label: "Curso Técnico" },
      { value: "Ensino Fundamental", label: "Ensino Fundamental" },
      { value: "Ensino Médio", label: "Ensino Médio" },
      { value: "Ensino Técnico", label: "Ensino Técnico" },
      { value: "Ensino Superior", label: "Ensino Superior" },
      { value: "Pós Graduação", label: "Pós Graduação" },
      { value: "Mestrado", label: "Mestrado" },
      { value: "Doutorado", label: "Doutorado" },
      { value: "Pós Doutorado", label: "Pós Doutorado" },
      { value: "Outros Cursos", label: "Outros Cursos" }
    ],
    levels: [
      { value: "Incompleto", label: "Incompleto" },
      { value: "Em andamento", label: "Em andamento" },
      { value: "Completo", label: "Completo" }
    ],
    higherEducation: [
      "Administração",
      "Administração Pública",
      "Agrimensura",
      "Agroecologia",
      "Agronegócios e Agropecuária",
      "Agronomia",
      "Alimentos",
      "Análise e Desenvolvimento de Sistemas",
      "Animação",
      "Aquicultura",
      "Arqueologia",
      "Arquitetura e Urbanismo",
      "Arquivologia",
      "Artes",
      "Artes Visuais - Bacharelado",
      "Artes Visuais - Licenciatura",
      "Astronomia",
      "Automação Industrial",
      "Banco de Dados",
      "Biblioteconomia",
      "Biocombustíveis",
      "Biomedicina",
      "Biossistemas",
      "Biotecnologia",
      "Biotecnologia e Bioquímica",
      "Ciência da Computação",
      "Ciência da Terra",
      "Ciência e Economia",
      "Ciência e Tecnologia",
      "Ciência e Tecnologia das Águas/do Mar",
      "Ciência e Tecnologia de Alimentos",
      "Ciências Aeronáuticas",
      "Ciências Agrárias",
      "Ciências Atuariais",
      "Ciências Biológicas",
      "Ciências Contábeis",
      "Ciências da Natureza e suas Tecnologias",
      "Ciências do Consumo",
      "Ciências Econômicas",
      "Ciências Humanas",
      "Ciências Naturais",
      "Ciências Sociais",
      "Cinema e Audiovisual",
      "Comércio Exterior",
      "Computação",
      "Comunicação das Artes do Corpo",
      "Comunicação em Mídias Digitais",
      "Comunicação Institucional",
      "Comunicação Organizacional",
      "Conservação e Restauro",
      "Construção Civil",
      "Construção Naval",
      "Cooperativismo",
      "Cultura, Linguagens e Tecnologias Aplicadas",
      "Dança",
      "Defesa e Gestão Estratégica Internacional",
      "Design",
      "Design de Games",
      "Design de Interiores",
      "Design de Moda",
      "Direito",
      "Ecologia",
      "Educação Física",
      "Educomunicação",
      "Eletrônica Industrial",
      "Eletrotécnica Industrial",
      "Energia e Sustentabilidade",
      "Energias Renováveis",
      "Enfermagem",
      "Engenharia Acústica",
      "Engenharia Aeronáutica",
      "Engenharia Agrícola",
      "Engenharia Ambiental e Sanitária",
      "Engenharia Biomédica",
      "Engenharia Bioquímica e de Biotecnologia",
      "Engenharia Cartográfica e de Agrimensura",
      "Engenharia Civil",
      "Engenharia de Alimentos",
      "Engenharia de Bioprocessos",
      "Engenharia de Biossistemas",
      "Engenharia de Computação",
      "Engenharia de Controle e Automação",
      "Engenharia de Energia",
      "Engenharia de Fortificação e Construção",
      "Engenharia de Inovação",
      "Engenharia de Materiais",
      "Engenharia de Minas",
      "Engenharia de Pesca",
      "Engenharia de Petróleo",
      "Engenharia de Produção",
      "Engenharia de Segurança no Trabalho",
      "Engenharia de Sistemas",
      "Engenharia de Software",
      "Engenharia de Telecomunicações",
      "Engenharia de Transporte e da Mobilidade",
      "Engenharia Elétrica",
      "Engenharia Eletrônica",
      "Engenharia Física",
      "Engenharia Florestal",
      "Engenharia Hídrica",
      "Engenharia Industrial Madeireira",
      "Engenharia Mecânica",
      "Engenharia Mecânica de Armamentos",
      "Engenharia Mecânica de Veículos Militares",
      "Engenharia Mecatrônica",
      "Engenharia Metalúrgica",
      "Engenharia Naval",
      "Engenharia Nuclear",
      "Engenharia Química",
      "Engenharia Têxtil",
      "Escrita Criativa",
      "Esporte",
      "Estatística",
      "Estética e Cosmética",
      "Estudos de Gênero e Diversidade",
      "Estudos de Mídia",
      "Eventos",
      "Fabricação Mecânica",
      "Farmácia",
      "Filosofia",
      "Física",
      "Fisioterapia",
      "Fonoaudiologia",
      "Fotografia",
      "Gastronomia",
      "Geofísica",
      "Geografia",
      "Geologia",
      "Geoprocessamento",
      "Gerontologia",
      "Gestão Ambiental",
      "Gestão Comercial",
      "Gestão da Informação",
      "Gestão da Produção Industrial",
      "Gestão da Qualidade",
      "Gestão da Tecnologia da Informação",
      "Gestão de Cooperativas",
      "Gestão de Recursos Humanos",
      "Gestão de Segurança Privada",
      "Gestão de Seguros",
      "Gestão de Turismo",
      "Gestão Desportiva e de Lazer",
      "Gestão em Saúde",
      "Gestão Financeira",
      "Gestão Hospitalar",
      "Gestão Pública",
      "História",
      "História da Arte",
      "Hotelaria",
      "Humanidades",
      "Informática",
      "Informática Biomédica",
      "Irrigação e Drenagem",
      "Jogos Digitais",
      "Jornalismo",
      "Letras em Língua Estrangeira",
      "Letras em Língua Portuguesa",
      "Libras",
      "Linguagens e Códigos e suas Tecnologias",
      "Linguística",
      "Logística",
      "Luteria",
      "Manutenção de Aeronaves",
      "Manutenção Industrial",
      "Marketing",
      "Matemática",
      "Matemática e Computação e suas Tecnologias",
      "Materiais",
      "Mecatrônica Industrial",
      "Medicina",
      "Medicina Veterinária",
      "Meteorologia",
      "Mineração",
      "Museologia",
      "Música",
      "Musicoterapia",
      "Nanotecnologia",
      "Naturologia",
      "Negócios Imobiliários",
      "Nutrição",
      "Obstetrícia",
      "Oceanografia",
      "Odontologia",
      "Oftálmica",
      "Optometria",
      "Papel e Celulose",
      "Pedagogia",
      "Petróleo e Gás",
      "Pilotagem Profissional de Aeronaves",
      "Processos Gerenciais",
      "Processos Metalúrgicos",
      "Processos Químicos",
      "Produção Audiovisual",
      "Produção Cênica",
      "Produção Cultural",
      "Produção de Bebidas",
      "Produção Editorial",
      "Produção Fonográfica",
      "Produção Multimídia",
      "Produção Publicitária",
      "Produção Sucroalcooleira",
      "Produção Têxtil",
      "Psicologia",
      "Psicopedagogia",
      "Publicidade e Propaganda",
      "Química",
      "Quiropraxia",
      "Radio, TV, Internet (Comunicação Audiovisual e Multimídia)",
      "Radiologia",
      "Redes de Computadores",
      "Relações Internacionais",
      "Relações Públicas",
      "Rochas Ornamentais",
      "Saneamento Ambiental",
      "Saúde",
      "Saúde Coletiva",
      "Secretariado",
      "Secretariado Executivo",
      "Segurança da Informação",
      "Segurança no Trabalho",
      "Segurança Pública",
      "Serviço Social",
      "Serviços Judiciários e Notariais",
      "Silvicultura",
      "Sistemas Biomédicos",
      "Sistemas da Informação",
      "Sistemas de Telecomunicações",
      "Sistemas Elétricos",
      "Sistemas Embarcados",
      "Sistemas para Internet",
      "Teatro",
      "Tecnologia da Informação",
      "Teologia",
      "Terapia Ocupacional",
      "Tradutor e Intérprete",
      "Transporte",
      "Turismo",
      "Zootecnia"
    ]
  }),
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    inProgress() {
      return this.payload.level === "Em andamento";
    }
  },
  methods: {
    closePage() {
      this.$router.back();
    },
    onLevelChange(value) {
      if (value === "Em andamento") {
        this.payload.to_date = "";
      }
    },
    isDisabled() {
      return (
        this.payload.scholarity == "Ensino Fundamental" ||
        this.payload.scholarity == "Ensino Médio"
      );
    },
    showCourse() {
      return (
        this.payload.scholarity == "Ensino Técnico" ||
        this.payload.scholarity == "Ensino Superior" ||
        this.payload.scholarity == "Pós Graduação" ||
        this.payload.scholarity == "Mestrado" ||
        this.payload.scholarity == "Doutorado"
      );
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      this.$vs.loading({ text: "Enviando..." });

      const { company_label } = this.$router.history.current.params;

      const formationPayload = { ...this.payload };
      if (this.inProgress) {
        formationPayload.to_date = "";
      }

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...formationPayload
            }
          ]
        })
        .then(response => {
          this.$vs.loading.close();

          if (this.payload.id) {
            this.$store.dispatch("formation/update", {
              ...formationPayload
            });
          } else {
            this.$store.dispatch("formation/store", {
              ...formationPayload,
              id: response.data.data.formations[0].id
            });
            // PostHog: formation_added
            (async () => {
              try {
                const { trackEvent } = await import("@/services/posthog");
                trackEvent("formation_added", {
                  institute: this.payload.institute,
                  scholarity: this.payload.scholarity,
                  level: this.payload.level,
                  grade: this.payload.grade,
                  from_date: this.payload.from_date,
                  to_date: formationPayload.to_date
                });
              } catch (_) {}
            })();
          }

          this.$router.back();
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            title: "Falha ao adicionar Formação",
            text: err.response.data.errors[0].errors,
            position: "top-right",
            time: 3200
          });

        });
    }
  },
  created() {
    this.$validator.extend(
      "monthYear",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique a data informada",
        validate: value =>
          new Promise(resolve => {
            if (parseInt(value.split("/")[0]) > 12)
              resolve({
                valid: false,
                data: {
                  message: `O mês ${value.split("/")[0]
                    } informado não é válido!`
                }
              });
            else
              resolve({
                valid: true,
                data: { message: "" }
              });
          })
      },
      { hasTarget: true, immediate: false }
    );

    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: value => {
          return new Promise(resolve => {
            if (!this.payload.is_current) {
              if (this.payload.from_date == "")
                resolve({
                  valid: false,
                  data: { message: "A data de início está vazia!" }
                });

              const splitFrom = "01/".concat(this.payload.from_date).split("/");
              const splitTo = "01/".concat(value).split("/");

              const monthReg = /0[1-9]|1[0-2]/;
              const yearReg = /(?:(?:19|20)[0-9]{2})/;

              if (!splitFrom[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitFrom[1]} informado na data de início não é válido!`
                  }
                });
              if (!splitTo[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitTo[1]} informado não é válido!`
                  }
                });

              if (!splitFrom[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitFrom[2]} informado na data de início não é válido!`
                  }
                });
              if (!splitTo[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitTo[2]} informado não é válido!`
                  }
                });

              const from = new Date(
                splitFrom[2],
                splitFrom[1] - 1,
                splitFrom[0]
              );
              const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

              resolve({
                valid: isBefore(from, to),
                data: {
                  message: `${isBefore(from, to)
                    ? ""
                    : "A data de finalização não pode ser menor que a data de início"
                    }`
                }
              });
            }
          });
        }
      },
      { hasTarget: true, immediate: false }
    );

    if (this.formation) {
      this.payload = {
        ...this.formation
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}

.text-warning {
  color: #FF8B00;
}
</style>